import * as Actions from "../../actions/app"
import { toggleIdInArray } from "utils/toggle-id-in-array"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_unit_measures: false,
  unit_measures: [],
  updating_unit_measure_ids: []
}

const unitMeasuresReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_UNIT_MEASURES: {
      return {
        ...state,
        loading_unit_measures: action.payload.loading,
        unit_measures: action.payload.data ?? state.unit_measures
      }
    }
    case Actions.UPDATE_UNIT_MEASURE_STATUS: {
      return {
        ...state,
        updating_unit_measure_ids: toggleIdInArray(state.updating_unit_measure_ids, action.payload.updating_id),
        unit_measures: addOrUpdateObjectInArray(state.unit_measures, action.payload.data, 'unidad_medida_id')
      }
    }
    default: {
      return state
    }
  }
}
export default unitMeasuresReducer
